import React, { useState } from 'react';
import PnLCorrelations from '../components/pnl/PnLCorrelations';
import PnLCharts from '../components/pnl/PnLCharts';

import './MarketRisk.css';
import PageShell from '../components/layout/PageShell';
import MarketRiskDashboard from "./MarketRiskDashboard";
import MarketRisStressTestsGrid from "../components/market-risk/MarketRiskStressTestsGrid";
import RiskExplainPivotTable from "../components/positions/RiskExplainPivotTable";
import SPMatrixGrid from "../components/positions/SPMatrixGrid";
import MarketRiskStressChart from "../components/market-risk/MarketRiskStressChart";
import FundingDashboard from "./FundingDashboard";


type ViewType = 'dashboard' | string | null;

const FundingRisk: React.FC = () => {
  const [activeView, setActiveView] = useState<ViewType>('dashboard');


return (
     <PageShell>

      <nav className="nav-bar">
        <div
          className={`nav-item ${activeView === 'dashboard' ? 'active' : ''}`}
          onClick={() => setActiveView('dashboard')}
        >
          Dashboard
        </div>
        {/* <div*/}
        {/*  className={`nav-item ${activeView === 'risk_explain' ? 'active' : ''}`}*/}
        {/*  onClick={() => setActiveView('risk_explain')}*/}
        {/*>*/}
        {/*  Risk Explain*/}
        {/*</div>*/}
        {/*    <div*/}
        {/*  className={`nav-item ${activeView === 'structured_products_vol' ? 'active' : ''}`}*/}
        {/*  onClick={() => setActiveView('structured_products_vol')}*/}
        {/*>*/}
        {/*  Structured Products*/}
        {/*</div>*/}
        {/*<div*/}
        {/*  className={`nav-item ${activeView === 'stress_tests' ? 'active' : ''}`}*/}
        {/*  onClick={() => setActiveView('stress_tests')}*/}
        {/*>*/}
        {/*  Stress Tests*/}
        {/*</div>*/}
        {/*<div*/}
        {/*  className={`nav-item ${activeView === 'stress_chart' ? 'active' : ''}`}*/}
        {/*  onClick={() => setActiveView('stress_chart')}*/}
        {/*>*/}
        {/*  Stress Chart*/}
        {/*</div>*/}


      </nav>
      <div className="view-stack">
      <div className={`view-pane ${activeView==='dashboard' ?'is-active':''}`}>
        <div className="market-risk-content-container">
          <button className="close-button" onClick={()=> setActiveView(null)}>×</button>
          <FundingDashboard />
        </div>
      </div>
    {/*   <div className={`view-pane ${activeView==='risk_explain' ?'is-active':''}`}>*/}
    {/*    <div className="market-risk-content-container">*/}
    {/*      <button className="close-button" onClick={()=> setActiveView(null)}>×</button>*/}
    {/*      <RiskExplainPivotTable  />*/}
    {/*    </div>*/}
    {/*  </div>*/}
    {/*   <div className={`view-pane ${activeView==='structured_products_vol' ?'is-active':''}`}>*/}
    {/*    <div className="market-risk-content-container">*/}
    {/*      <button className="close-button" onClick={()=> setActiveView(null)}>×</button>*/}
    {/*      <SPMatrixGrid/>*/}
    {/*    </div>*/}
    {/*  </div>*/}
    {/*  <div className={`view-pane ${activeView==='stress_tests' ?'is-active':''}`}>*/}
    {/*    <div className="market-risk-content-container">*/}
    {/*      <button className="close-button" onClick={()=> setActiveView(null)}>×</button>*/}
    {/*      <MarketRisStressTestsGrid />*/}
    {/*    </div>*/}
    {/*  </div>*/}

    {/*</div>*/}
    {/*      <div className={`view-pane ${activeView==='stress_chart' ? 'is-active' : ''} view-pane--stress-chart`}>*/}
    {/*    <div className="market-risk-content-container">*/}
    {/*      <button className="close-button" onClick={()=> setActiveView(null)}>×</button>*/}
    {/*      <MarketRiskStressChart/>*/}
    {/*    </div>*/}
      </div>


     </PageShell> );
};

export default FundingRisk;
